import PagePlaceholder from '../components/PagePlaceholder.jsx';

export default function AdminPlayers() {
  return (
    <PagePlaceholder
      title="Players"
      note="Roster, guest linking, account merge."
    />
  );
}
